function cstm_recommended_init() {
  console.log('cstm_recommended: Starting initialization...');
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      cstm_recommended_setup();
    });
  } else {
    cstm_recommended_setup();
  }
  
  function cstm_recommended_setup() {
    console.log('cstm_recommended: Setting up...');
    // Initial setup
    cstm_recommended_initializeAll();
    
    // Set up observer for dynamic content
    cstm_recommended_setupObserver();
    
    // Fallback: check every 500ms for 10 seconds
    cstm_recommended_startFallbackCheck();
  }
  
  function cstm_recommended_initializeAll() {
    const sections = document.querySelectorAll('.cstm_recommended');
    console.log(`cstm_recommended: Found ${sections.length} sections`);
    
    sections.forEach(section => {
      cstm_recommended_initializeSection(section);
    });
  }
  
  function cstm_recommended_initializeSection(section) {
    // Look for variant selects within the product cards inside the section
    const selects = section.querySelectorAll('.variant-select');
    console.log(`cstm_recommended: Found ${selects.length} variant selects in section`);
    
    selects.forEach(select => {
      if (select.hasAttribute('data-cstm-init')) {
        console.log('cstm_recommended: Select already initialized, skipping');
        return;
      }
      
      console.log('cstm_recommended: Initializing variant select:', select);
      select.setAttribute('data-cstm-init', 'true');
      select.addEventListener('change', cstm_recommended_handleVariantChange);
      
      // Update price on page load for the initially selected variant
      cstm_recommended_updatePriceOnLoad(select);
    });
  }
  
  function cstm_recommended_updatePriceOnLoad(selectElement) {
    console.log('cstm_recommended: Updating price on page load for variant:', selectElement.value);
    
    const productCard = selectElement.closest('.card-wrapper, .product-card-wrapper');
    if (!productCard) {
      console.error('cstm_recommended: Product card not found');
      return;
    }
    
    const priceContainer = productCard.querySelector('.price');
    if (!priceContainer) {
      console.error('cstm_recommended: Price container not found');
      return;
    }
    
    // Store the original content for comparison
    const originalContent = priceContainer.innerHTML;
    
    const productId = selectElement.dataset.productId;
    const variantId = selectElement.value;
    
    if (!productId) {
      console.error('cstm_recommended: Could not get product ID');
      return;
    }
    
    console.log(`cstm_recommended: Fetching price on load for product ${productId}, variant ${variantId}`);
    
    // Get product data and update price
    cstm_recommended_getProductData(productId, variantId, priceContainer, originalContent, true);
  }
  
  function cstm_recommended_handleVariantChange(event) {
    console.log('cstm_recommended: Variant changed');
    cstm_recommended_updatePriceOnChange(event.target);
  }
  
  function cstm_recommended_updatePriceOnChange(selectElement) {
    console.log('cstm_recommended: Updating price on variant change for:', selectElement.value);
    
    const productCard = selectElement.closest('.card-wrapper, .product-card-wrapper');
    if (!productCard) {
      console.error('cstm_recommended: Product card not found');
      return;
    }
    
    const priceContainer = productCard.querySelector('.price');
    if (!priceContainer) {
      console.error('cstm_recommended: Price container not found');
      return;
    }
    
    const originalContent = priceContainer.innerHTML;
    priceContainer.innerHTML = '<div class="cstm_recommended-price-loading">Loading...</div>';
    
    const productId = selectElement.dataset.productId;
    const variantId = selectElement.value;
    
    if (!productId) {
      console.error('cstm_recommended: Could not get product ID');
      priceContainer.innerHTML = originalContent;
      return;
    }
    
    console.log(`cstm_recommended: Fetching price on change for product ${productId}, variant ${variantId}`);
    
    // Method 1: Try to get product data and find variant
    cstm_recommended_getProductData(productId, variantId, priceContainer, originalContent, false);
  }
  
  function cstm_recommended_getProductData(productId, variantId, priceContainer, originalContent, isPageLoad = false) {
    // Try to fetch product data from Shopify's JSON API
    fetch(`/products/${cstm_recommended_getProductHandleFromId(productId)}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('cstm_recommended: Received product data:', product);
        
        // Find the specific variant in the product data
        const variant = product.variants.find(v => v.id == variantId);
        if (variant) {
          console.log('cstm_recommended: Found variant:', variant);
          
          // Convert cents to dollars for display
          const priceInDollars = variant.price / 100;
          const comparePriceInDollars = variant.compare_at_price ? variant.compare_at_price / 100 : null;
          
          console.log('cstm_recommended: Prices in dollars:', { 
            price: priceInDollars, 
            comparePrice: comparePriceInDollars 
          });
          
          // Only update if the price is different from current display (for page load)
          if (isPageLoad) {
            cstm_recommended_updatePriceDisplayIfNeeded(priceContainer, priceInDollars, comparePriceInDollars, originalContent);
          } else {
            cstm_recommended_updatePriceDisplay(priceContainer, priceInDollars, comparePriceInDollars);
          }
        } else {
          throw new Error('Variant not found in product data');
        }
      })
      .catch(error => {
        console.error('cstm_recommended: Product JSON method failed:', error);
        if (!isPageLoad) {
          // Only show error fallback for change events, not page load
          cstm_recommended_trySectionsAPI(productId, variantId, priceContainer, originalContent);
        }
      });
  }
  
  function cstm_recommended_updatePriceDisplayIfNeeded(priceContainer, price, comparePrice, originalContent) {
    // For page load, only update if the price is different from what's currently displayed
    const currentPriceText = priceContainer.querySelector('.price-item--last, .price-item--regular')?.textContent || '';
    const newPriceText = cstm_recommended_formatMoney(price);
    
    console.log('cstm_recommended: Comparing prices - current:', currentPriceText, 'new:', newPriceText);
    
    // If prices are different, update the display
    if (currentPriceText.trim() !== newPriceText.trim()) {
      console.log('cstm_recommended: Prices differ, updating display');
      cstm_recommended_updatePriceDisplay(priceContainer, price, comparePrice);
    } else {
      console.log('cstm_recommended: Prices are the same, no update needed');
    }
  }
  
  function cstm_recommended_trySectionsAPI(productId, variantId, priceContainer, originalContent) {
    // Try using the sections API which might have the variant data
    fetch(`/variants/${variantId}/?section_id=product-recommendations`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        console.log('cstm_recommended: Received sections HTML');
        // Parse the HTML to find price information
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        // Look for price elements in the response
        const priceElement = tempDiv.querySelector('.price');
        if (priceElement) {
          priceContainer.innerHTML = priceElement.innerHTML;
          console.log('cstm_recommended: Price updated from sections API');
        } else {
          throw new Error('No price element found in sections response');
        }
      })
      .catch(error => {
        console.error('cstm_recommended: Sections API failed:', error);
        // Extract from current option text as fallback
        cstm_recommended_extractPriceFromCurrentState(priceContainer, originalContent);
      });
  }
  
  function cstm_recommended_extractPriceFromCurrentState(priceContainer, originalContent) {
    console.log('cstm_recommended: Using current price state');
    // Just keep the current price display since we can't get new data
    priceContainer.innerHTML = originalContent;
    console.log('cstm_recommended: Restored original price display');
  }
  
  function cstm_recommended_updatePriceDisplay(priceContainer, price, comparePrice) {
    console.log('cstm_recommended: Updating price display with dollars:', { price, comparePrice });
    
    // Format the prices (now in dollars)
    const formattedPrice = cstm_recommended_formatMoney(price);
    const formattedComparePrice = comparePrice ? cstm_recommended_formatMoney(comparePrice) : null;
    
    console.log('cstm_recommended: Formatted prices:', { formattedPrice, formattedComparePrice });
    
    if (formattedComparePrice && formattedComparePrice !== formattedPrice) {
      // Product is on sale
      priceContainer.innerHTML = `
        <div class="price__container">
          <div class="price__sale">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span>
              <s class="price-item price-item--regular">${formattedComparePrice}</s>
            </span>
            <span class="visually-hidden visually-hidden--inline">Sale price</span>
            <span class="price-item price-item--sale price-item--last">${formattedPrice}</span>
          </div>
        </div>
      `;
    } else {
      // Regular price
      priceContainer.innerHTML = `
        <div class="price__container">
          <div class="price__regular">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span class="price-item price-item--regular">${formattedPrice}</span>
          </div>
        </div>
      `;
    }
    
    console.log('cstm_recommended: Price updated successfully');
  }
  
  function cstm_recommended_formatMoney(amount) {
    console.log('cstm_recommended: Formatting dollar amount:', amount);
    
    const formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
    
    console.log('cstm_recommended: Formatted amount:', formatted);
    return formatted;
  }
  
  function cstm_recommended_getProductHandleFromId(productId) {
    // This is a helper function - you might need to adjust this based on your theme
    // For now, we'll try to get the handle from the product card
    const productCard = document.querySelector(`[data-product-id="${productId}"]`)?.closest('.card-wrapper, .product-card-wrapper');
    if (productCard) {
      return cstm_recommended_getProductHandle(productCard);
    }
    return '';
  }
  
  function cstm_recommended_getProductHandle(productCard) {
    const link = productCard.querySelector('a[href*="/products/"]');
    if (!link) {
      console.error('cstm_recommended: Product link not found');
      return '';
    }
    
    const href = link.getAttribute('href');
    const match = href.match(/\/products\/([^?]+)/);
    const handle = match ? match[1] : '';
    
    console.log('cstm_recommended: Extracted product handle:', handle);
    return handle;
  }
  
  function cstm_recommended_setupObserver() {
    console.log('cstm_recommended: Setting up mutation observer');
    
    const observer = new MutationObserver(function(mutations) {
      let foundNewContent = false;
      
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if the added node is our section or contains it
            if (node.classList && node.classList.contains('cstm_recommended')) {
              foundNewContent = true;
            } else if (node.querySelector && node.querySelector('.cstm_recommended')) {
              foundNewContent = true;
            }
            
            // Also check if variant selects were added directly
            if (node.querySelector && node.querySelector('.variant-select')) {
              foundNewContent = true;
            }
          }
        });
      });
      
      if (foundNewContent) {
        console.log('cstm_recommended: New content detected, reinitializing...');
        setTimeout(() => {
          cstm_recommended_initializeAll();
        }, 300);
      }
    });
    
    // Wait a bit before starting observer
    setTimeout(() => {
      const target = document.body || document.documentElement;
      if (target) {
        observer.observe(target, { childList: true, subtree: true });
        console.log('cstm_recommended: Mutation observer started');
      } else {
        console.error('cstm_recommended: No target found for observer');
      }
    }, 100);
  }
  
  function cstm_recommended_startFallbackCheck() {
    console.log('cstm_recommended: Starting fallback checks');
    
    let attempts = 0;
    const maxAttempts = 20; // 10 seconds total
    
    const interval = setInterval(() => {
      const sections = document.querySelectorAll('.cstm_recommended');
      let foundNew = false;
      
      sections.forEach(section => {
        if (!section.hasAttribute('data-cstm-checked')) {
          section.setAttribute('data-cstm-checked', 'true');
          console.log('cstm_recommended: Fallback check found new section');
          cstm_recommended_initializeSection(section);
          foundNew = true;
        }
        
        // Also check for new variant selects in existing sections
        const newSelects = section.querySelectorAll('.variant-select:not([data-cstm-init])');
        if (newSelects.length > 0) {
          console.log(`cstm_recommended: Fallback check found ${newSelects.length} new selects`);
          newSelects.forEach(select => {
            select.setAttribute('data-cstm-init', 'true');
            select.addEventListener('change', cstm_recommended_handleVariantChange);
            // Also update price on load for newly found selects
            cstm_recommended_updatePriceOnLoad(select);
          });
          foundNew = true;
        }
      });
      
      if (foundNew) {
        console.log('cstm_recommended: Fallback check processed new elements');
      }
      
      attempts++;
      if (attempts >= maxAttempts) {
        console.log('cstm_recommended: Fallback checks completed');
        clearInterval(interval);
      }
    }, 500);
  }
}

// Safe initialization
if (typeof document !== 'undefined') {
  cstm_recommended_init();
} else {
  console.log('cstm_recommended: Document not available, waiting for load');
  if (typeof window !== 'undefined') {
    window.addEventListener('load', cstm_recommended_init);
  }
}